(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[263],{

/***/ 43738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Config; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92233);



function Config(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swr__WEBPACK_IMPORTED_MODULE_1__/* .SWRConfig */ .J$, {
        value: {
            refreshInterval: 1000 * 60 * 2,
            fetcher: function(q, variables) {
                return (0,utils_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(q, variables);
            },
            fallback: fallback
        },
        children: children
    });
};


/***/ }),

/***/ 45033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Attributes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_attributeKeyMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71100);



function Attributes(param) {
    var attributes = param.attributes, title = param.title;
    if (!Array.isArray(attributes) || !attributes.length) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-5 sm:px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg font-medium leading-6 text-gray-900",
                    children: title !== null && title !== void 0 ? title : "Attributes"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border-t border-gray-200 px-4 py-5 sm:p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
                    className: "sm:divide-y sm:divide-gray-200",
                    children: attributes.map(function(attribute) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500",
                                    children: utils_attributeKeyMap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[attribute.ValueType] || attribute.ValueType
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                    className: "mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0",
                                    children: attribute.Link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: attribute.Link,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: attribute.Link,
                                            className: "no-underline hover:underline",
                                            children: attribute.Value
                                        })
                                    }) : attribute.Value
                                })
                            ]
                        }, attribute.ValueType);
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 43228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25575);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);

/* eslint-disable react/no-array-index-key */ 


function Pagination(param) {
    var items = param.items;
    var pages = items || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "mb-10 flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
            className: "flex space-x-4 rounded-md bg-white px-6 shadow",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "flex",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "text-gray-400 hover:text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        className: "h-5 w-5 flex-shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Home"
                                    })
                                ]
                            })
                        })
                    })
                }),
                pages.map(function(page, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                            "flex last-of-type:hidden md:last-of-type:flex": pages.length > 1
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "h-full w-6 flex-shrink-0 text-gray-200",
                                    viewBox: "0 0 24 44",
                                    preserveAspectRatio: "none",
                                    fill: "currentColor",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: page.linkAs,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                        "aria-current": page.current ? "page" : undefined,
                                        children: page.name
                                    })
                                })
                            ]
                        })
                    }, "breadcrumb-".concat(page.name, "-").concat(index));
                })
            ]
        })
    });
};


/***/ }),

/***/ 16763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var context_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40714);
/* harmony import */ var _cover_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14102);
/* harmony import */ var _cover_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_cover_module_css__WEBPACK_IMPORTED_MODULE_4__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/* eslint-disable @next/next/no-img-element */ 



var Cover = function(_param) {
    var props = _extends({}, _param);
    var title = props.title, classes = props.classes, image = props.image;
    var setTransparentHeader = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_app__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).setTransparentHeader;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setTransparentHeader(true);
        return function() {
            setTransparentHeader(false);
        };
    }, [
        setTransparentHeader
    ]);
    var titleHtml = null;
    if (title) {
        titleHtml = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mb-3 text-3xl font-bold text-white lg:text-5xl"),
            children: title
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative w-full bg-black", (_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().cover), classes),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute inset-0 bottom-0 w-full", (_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().figure)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "w-full object-cover object-center",
                        src: "https://images.opencoaster.com/767x250/".concat(image.hash).concat(image.ext),
                        alt: image.alternativeText ? image.alternativeText : title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute bottom-0 right-0 p-1 font-mono text-white text-opacity-75 transition-opacity duration-200 ease-in-out", (_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().caption)),
                        children: image.caption
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_cover_module_css__WEBPACK_IMPORTED_MODULE_4___default().titleBg), "relative w-full pb-2 pt-20"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container mx-auto px-6 sm:px-0",
                    children: titleHtml
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Cover);


/***/ }),

/***/ 37999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Gallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./hooks/useBodyClass.js

var addBodyClass = function(className) {
    return document.body.classList.add(className);
};
var removeBodyClass = function(className) {
    return document.body.classList.remove(className);
};
function useBodyClass(className) {
    (0,react.useEffect)(function() {
        if (Array.isArray(className)) {
            className.map(addBodyClass);
        } else {
            addBodyClass(className);
        }
        // Clean up
        return function() {
            if (Array.isArray(className)) {
                className.map(removeBodyClass);
            } else {
                removeBodyClass(className);
            }
        };
    }, [
        className
    ]);
};

// EXTERNAL MODULE: ./components/global/gallery.module.css
var gallery_module = __webpack_require__(90061);
var gallery_module_default = /*#__PURE__*/__webpack_require__.n(gallery_module);
;// CONCATENATED MODULE: ./components/global/gallery-card.jsx




function GalleryCard(param) {
    var showModal = param.showModal, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: "block overflow-hidden rounded",
        href: "https://images.opencoaster.com/1600x/".concat(image.hash).concat(image.ext),
        onClickCapture: function(e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            showModal(image);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
            className: classnames_default()("relative", (gallery_module_default()).figure),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "https://images.opencoaster.com/800x/".concat(image.hash).concat(image.ext),
                    alt: image.alternativeText,
                    layout: "intrinsic",
                    height: image.height,
                    width: image.width,
                    unoptimized: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                    className: classnames_default()("absolute bottom-0 right-0 p-1 font-mono text-white text-opacity-75", (gallery_module_default()).caption),
                    children: image.caption
                })
            ]
        })
    }, "Gallery-0");
};

;// CONCATENATED MODULE: ./components/global/gallery.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







function Gallery(_param) {
    var item = _param.item, className = _param.className, props = _objectWithoutProperties(_param, [
        "item",
        "className"
    ]);
    var ref, ref1;
    var ref2 = (0,react.useState)(false), modalOpen = ref2[0], setModalOpen = ref2[1];
    var ref3 = (0,react.useState)(), modalImage = ref3[0], setModalImage = ref3[1];
    var showModal = function(image) {
        window.scrollTo(0, 0);
        setModalImage(image);
        setModalOpen(true);
    };
    useBodyClass(modalOpen ? "overflow-hidden" : "overflow-auto");
    if (!item.MainPhoto && !(item === null || item === void 0 ? void 0 : (ref = item.Gallery) === null || ref === void 0 ? void 0 : ref.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
                className: className
            }, props, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-10 overflow-hidden rounded-lg bg-white shadow",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 py-5 sm:p-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5 border-b border-gray-200 pb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "flex-1 text-2xl font-bold text-gray-900",
                                    children: "Gallery"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-2 gap-8 last:mb-0 md:grid-cols-2 lg:grid-cols-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryCard, {
                                        showModal: showModal,
                                        image: item.MainPhoto
                                    }),
                                    item === null || item === void 0 ? void 0 : (ref1 = item.Gallery) === null || ref1 === void 0 ? void 0 : ref1.map(function(image, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryCard, {
                                            showModal: showModal,
                                            image: image
                                        }, "Gallery-".concat(index + 1));
                                    })
                                ]
                            })
                        ]
                    })
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("absolute top-0 left-0 z-20 h-screen w-screen overflow-hidden bg-gray-900 bg-opacity-95 p-8", {
                    hidden: !modalOpen
                }),
                onClick: function() {
                    return setModalOpen(false);
                },
                onKeyPress: function(e) {
                    if (e.key === "Escape") {
                        setModalOpen(false);
                    }
                },
                role: "button",
                "aria-label": "Close",
                tabIndex: 0,
                children: modalImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                    className: "relative h-full w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "https://images.opencoaster.com/1600x/".concat(modalImage.hash).concat(modalImage.ext),
                            alt: modalImage.alternativeText,
                            layout: "fill",
                            // height={modalImage.height}
                            // width={modalImage.width}
                            unoptimized: true,
                            className: "object-contain"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                            className: classnames_default()("absolute bottom-0 right-0 p-1 font-mono text-white text-opacity-75", (gallery_module_default()).caption),
                            children: modalImage.caption
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 36551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);


function Throw404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
        statusCode: 404
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Throw404);


/***/ }),

/***/ 20519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MainPhoto on UploadFile {\n    caption\n    alternativeText\n    hash\n    ext\n    width\n    height\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainPhoto = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (MainPhoto);


/***/ }),

/***/ 71100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var ATTRIBUTES = {
    MANUFACTURER: "Manufacturer",
    CAPACITY: "Capacity",
    HEIGHT: "Height",
    MAX_SPEED: "Max Speed",
    HEIGHT_RESTRICTION: "Height Restriction",
    TRACK_LAYOUT: "Track Layout",
    INVERSIONS: "Inversions",
    LENGTH: "Length",
    DURATION: "Duration",
    ADMISSION_COST: "Admission Cost",
    PROPULSION: "Propulsion System",
    RESTRAINTS: "Restraints",
    DROP: "Drop"
};
/* harmony default export */ __webpack_exports__["Z"] = (ATTRIBUTES);


/***/ }),

/***/ 92233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ query1; }
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96519);


function query1(query, args) {
    var variables = args;
    var token;
    if (args === null || args === void 0 ? void 0 : args.variables) {
        variables = args.variables;
    }
    if ((args === null || args === void 0 ? void 0 : args.token) && typeof (args === null || args === void 0 ? void 0 : args.token) === "string") {
        token = args.token;
    }
    var client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(utils_const__WEBPACK_IMPORTED_MODULE_1__/* .GRAPH_URL */ .Vd);
    if (token) {
        client.setHeader("authorization", "Bearer ".concat(token));
    }
    return client.request(query, variables);
};


/***/ }),

/***/ 14102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover_cover__vrnbK","figure":"cover_figure__nguT5","caption":"cover_caption__vmK9W","titleBg":"cover_titleBg__7vBwg"};

/***/ }),

/***/ 90061:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"caption":"gallery_caption__xi8Pc"};

/***/ })

}]);